import loc from 'owa-localize';
import type { HotkeyCommand } from 'owa-hotkeys';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import createUniversalHotkeyCommand from 'owa-hotkeys/lib/utils/createUniversalHotkeyCommand';
import { goToCopilot } from './getCopilotDabHotkey.locstring.json';
import { getHotkey } from './hotkeyDefinition';

export const getCopilotDabHotkey = ():
    | {
          [index: string]: HotkeyCommand;
      }
    | undefined => {
    if (!isBizchatSidepaneEnabled()) {
        return undefined;
    }

    return {
        goToCopilot: {
            ...createUniversalHotkeyCommand('goTo', loc(goToCopilot), getHotkey()),
            preserveCtrl: true,
        },
    };
};
